<template>
    <NavBar :show="false" :bgcolor="$newYearStyle ? '#DAADA4' : '#a4beda'"></NavBar>
    <div class="search-box">
        <div class="head-input">
            <div class="left-icon">
                <router-link to="/">
                    <van-icon name="arrow-left" color="#fff" size="20" />
                </router-link>
            </div>
            <van-search
                class="search-item"
                shape="round"
                placeholder="请输入搜索关键词"
                v-model="keyword"
            >
                <template #left-icon>
                    <van-icon name="search" color="#fff" size="20" />
                </template>
                <template #right-icon>
                    <span class="seaBtn" @click="submit">搜索</span>
                </template>
            </van-search>
        </div>

        <div class="search-history hide">
            <section class="history-box">
                <section class="title-box">
                    <p>搜索历史</p>
                    <span class="clear-icon">
                        <van-icon name="clear" class="clear-item" />
                        清空
                    </span>
                </section>
                <div class="history-null">
                    <p>暂无记录</p>
                </div>
                <div class="history-list">
                    <span>搜索</span>
                    <span>历史</span>
                    <span>记录</span>
                </div>
            </section>

            <section class="hot-box">
                <p class="hot-title">热门搜索</p>
                <div class="hot-list">
                    <span>热门</span>
                    <span>话题</span>
                    <span>搜索</span>
                    <span>历史</span>
                    <span>记录</span>
                </div>
            </section>
        </div>

        <div class="result">
            <p class="title">搜索结果</p>
            <div class="result-null" v-if="! loading && ! products.length">
                <span>无相关搜索结果</span>
            </div>
            <div class="search-result" v-else>
                <div v-for="product in products" :key="product.id" @click="jumpLink(product.detail_url ? product.detail_url : ('/product/' + product.id))">
                    <div class="itemBox">
                        <div class="img-box">
                            <img :src="product.cover"/>
                            <div class="music" v-if="product.is_music">音乐</div>
                        </div>
                        <section class="right-box">
                            <span class="title">{{ product.name }}</span>
                            <div class="bottom">
                                <span class="tag-l">开售时间 {{ dateFormat('m月d日', product.release_time) }}</span>
                                <!-- <span class="tag-r">免费领取</span> -->
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>